import React from 'react';
import PropTypes from 'prop-types';
import Text from '../containers/Text';

const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
const isActive = dayIndex => {
  const today = (new Date()).getDay();
  // today: 0 = sunday
  // today: 1 = monday
  // dayIndex: 0 = monday
  // dayIndex: 1 = tuesday

  if (dayIndex == today - 1) {
    return true;
  }

  if (dayIndex == 6 && today == 0) {
    return true
  }

  return false;
}

const OpeningTimes = (props) => {
  if (!Array.isArray(props.hours)) {
    return <Text id='business-hours.unknown' />;
  }

  const times = props.hours.reduce((times, timeSlot) => {
    const index = days[timeSlot.weekday - 1];
    if(!times[index]) {
      times[index] = [];
    }

    times[index].push([
      timeSlot.openFrom, timeSlot.openTil
    ]);

    return times;
  }, {});

  return (
    <table className={`opening-times ${props.todayOnly ? 'only-today' : ''}`}>
      <tbody>
      {days.map((day, i) => (
        <tr key={i} className={`${isActive(i) ? 'active' : null}`}>
          <td key='day'><Text id={`days.full.${day}`}/></td>
          <td key='value'>
            {times[day] ? (
              times[day].map(i=>i.join(' - ')).join(', ')
            ) : <Text id='business-hours.closed' /> }
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  );
}

OpeningTimes.propTypes = {
  hours: PropTypes.array.isRequired
};

export default OpeningTimes;
